import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

import { DeviceCalibrationHistory } from "src/app/models/deviceCalibrationHistory.model";
import { DeviceCalibrationHistoryService } from "src/app/services/deviceCalibrationHistory.service";
import { GridModel } from "./../../shared/grid/grid.model";
import { LoaderService } from "src/app/services/loader.service";
import { MatTableSortOptions } from "src/app/models/sort.model";
import { ToastService } from "src/app/services/toast.service";

import { trackByIndex } from "src/app/shared/utils/track-by.util";
import { openFileInNewTab } from "src/app/shared/utils/file-link.util";
@Component({
  standalone: false,
    selector: "app-device-calibration-history",
    templateUrl: "./device-calibration-history.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./device-calibration-history.component.scss"],
})
export class DeviceCalibrationHistoryComponent implements OnInit {
    calibrationHistory: DeviceCalibrationHistory[] = [];
    itemsPerPage = 10;
    p = 1;
    gridCalibrationHistory: GridModel<DeviceCalibrationHistory>;
    @Input() filterValue: string;
    sortBy: string = "id";
    orderBy: string = "asc";

    @Output() hideHistoryView = new EventEmitter<boolean>();

    constructor(
        private deviceCalibrationHistoryService: DeviceCalibrationHistoryService,
        private toastService: ToastService,
        private loaderService: LoaderService,
    ) {}

    ngOnInit() {
        this.load("", "", 20);
    }

    onPageChange($event: number) {
        this.p = $event;
        this.load(this.orderBy, this.sortBy, this.itemsPerPage, this.p - 1);
    }

    hideView() {
        this.hideHistoryView.emit(true);
    }

    sort(sortBy: string) {
        if (this.sortBy == sortBy) {
            this.orderBy = this.orderBy == "asc" ? "desc" : "asc";
        } else {
            this.sortBy = sortBy;
            this.orderBy = "asc";
        }
        this.load(this.sortBy, this.orderBy);
    }

    sortDevicesByHistory(tableSortOptions: MatTableSortOptions) {
        this.orderBy = tableSortOptions.direction;
        this.sort(tableSortOptions.active);
    }

    load(orderBy = "id", sort = "asc", pageSize = 10, pageNumber = 0) {
        this.loaderService.show();
        this.deviceCalibrationHistoryService
            .get(this.filterValue, orderBy, sort, pageNumber, pageSize, "")
            .subscribe(
                (sensors) => {
                    this.loaderService.hide();
                    this.gridCalibrationHistory = sensors;
                    this.calibrationHistory = sensors.data;
                },
                (error) => {
                    this.toastService.showError(error);
                    this.loaderService.hide();
                },
            );
    }

    viewCertificate(url?: string): void {
        if (!openFileInNewTab(url)) {
            this.toastService.displayErrorMessage("Certificate URL not found", true);
        }
    }

    public trackByIndex = trackByIndex;
}
